import TableSimpleCell from "ds/components/TableSimple/Cell";

import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableDropdownCell = ({
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return <TableSimpleCell {...cellProps} />;
};

export default IntegrationsAwsUsedByTableDropdownCell;
